module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./StoreCardMsgView.js"));
	}, "StoreCardMsgView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StoreCardMsgView!./src/pages/Register/StoreCardMsg/StoreCardMsgView.js
// module id = 824
// module chunks = 438